<template>
  <v-container grid-list-xs>
    <div class="home text-center">
    <img alt="Vue logo" width="182px" src="https://www.escritorioadvocacia.org/imgempresas/gazzinelli-consultoria-18009-gYh5.jpg">
      <HomeScreen msg="Bem vindo ao sistema de Gestão de Clientes"/>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HomeScreen: () => import('@/components/HomeScreen.vue')
  }
}
</script>
